/**
 * Gates a route to reviewers only (users with My Daily Hue MCP connector access,
 * `is_reviewer = 1`). Non-reviewers — anonymous or signed-in — are sent home.
 * They should never have a link here, but a typed-in URL must not load it either.
 * This is a convenience gate; the API independently re-checks `is_reviewer`.
 */

import { Navigate } from 'react-router';
import { useAuth } from '../lib/auth';

export function RequireReviewer({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="p-6 text-sm text-[color:var(--text-muted)]">Loading…</div>;
  }
  if (user?.is_reviewer !== 1) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
